
import {promptMessage} from '@/api/dataHandling'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'


export default {
name: 'ShortAnswer',
components: {
XInput, CheckerItem, Group, Cell, XTextarea, Datetime
},
props: {
shortAnswer: {},
cuIndex: 0
},
data () {
return {
options: [],
userAnswer: '',
haOptions: ''
}
},
methods: {
valid () {
let anwer = this.shortAnswer.userAnswer
let type = this.shortAnswer.subjectType

console.log(type, anwer)
if (type) {
console.log(type, anwer)
if (type === 'phone' && anwer.length !== 11) {
this.shortAnswer.userAnswer = ''
this.userAnswer = ''
promptMessage('提醒', '请输入正确的手机号！')
}
if (type === 'cert' && anwer.length !== 15 && anwer.length !== 18) {
this.shortAnswer.userAnswer = ''
this.userAnswer = ''
promptMessage('提醒', '请输入正确的身份证号码！')
}
}
},
getAnswer () {
return this.shortAnswer
},
toggleOption (value) {
if (value) {
this.shortAnswer.userAnswer = value
}

if (value.length > 0 && this.haOptions.length === 0) {



}
}
}
}



// WEBPACK FOOTER //
// ./src/components/Subjects/ShortAnswer/index.vue